export default {
  'general': {
    'colors': {
      'active_color': '#2E5090',
      'text_color': '#2E2E2E',
      'warning_color': '#EF001A'
    },
    'font': {
      'family': 'Montserrat'
    },
    'form_width': '400px',
    'dynamic_height': true,
    'dynamic_fadein': false,
    'inherit_toggle': false
  },
  'typography': {
    'question_title': {
      'font': {
        'family': 'Poppins',
        'weight': '700',
        'size': '18',
        'line_height': '24',
        'color': '#2E2E2E'
      },
      'text_align': 'left'
    },
    'question_description': {
      'font': {
        'family': 'Poppins',
        'weight': '400',
        'size': '16',
        'line_height': '20',
        'color': '#6B7280'
      },
      'text_align': 'left'
    },
    'input_box': {
      'border': {
        'skin': 'all',
        'style': 'Solid',
        'width': '1',
        'color': '#E5E7EB'
      },
      'font': {
        'height': 'comfortable',
        'spacing': '20',
        'text_intent': '10',
        'family': 'Poppins',
        'color': '#2E5090',
        'background_color': '#fff',
        'font_size': '16'
      },
      'placeholder': {
        'color': '#2E5090'
      },
      'text_align': 'left',
      'radius': 'lg'
    },
    'text_box': {
      'color': '#2E2E2E',
      'family': 'Poppins'
    }
  },
  'ui_elements': {
    'background': {
      'color': '#ffffff',
      'image': '',
      'formColor': '#ffffff',
      'formShadow': true,
      'form_border_width': '1',
      'form_border_style': 'none',
      'form_border_color': '#dddddd',
      'form_border_radius': '0',
      'form_padding_left': '25',
      'form_padding_right': '25',
      'form_padding_top': '55',
      'form_padding_bottom': '25'
    },
    'question': {
      'asterisk_for_required': false,
      'hide_question_labels': false
    },
    'step_navigation': {
      'back_button': {
        'text': 'Go Back',
        'backgroundColor': '#FFFFFF',
        'width': '100',
        'alignment': 'left',
        'font': {
          'family': 'Poppins',
          'weight': '400',
          'size': '18',
          'line_height': '20',
          'color': '#E87722',
          'height': '50'
        },
        'rounded': false,
        'borderRadius': 'lg',
        'shadow': false,
        'icon': 'navigate_before',
        'iconPosition': '',
        'hide': false,
        'default_style': {
          'border': {
            'style': 'Solid',
            'color': '#E87722',
            'width': '1'
          }
        },
        'hover_style': {
          'color': '#E87722',
          'backgroundColor': '#FFFFFF',
          'border': {
            'style': 'Solid',
            'color': '#E87722',
            'width': '1'
          }
        },
        'active_style': {
          'color': '#E87722',
          'backgroundColor': '#FFFFFF',
          'border': {
            'style': 'Solid',
            'color': '#E87722',
            'width': '1'
          }
        }
      },
      'next_button': {
        'text': 'Continue',
        'backgroundColor': '#2E5090',
        'width': '100',
        'alignment': 'right',
        'font': {
          'family': 'Poppins',
          'weight': '400',
          'size': '18',
          'line_height': '20',
          'color': '#ffffff',
          'height': '50'
        },
        'rounded': false,
        'borderRadius': 'lg',
        'shadow': false,
        'icon': 'navigate_next',
        'iconPosition': '',
        'hidden': false,
        'default_style': {
          'border': {
            'style': 'None',
            'color': '#2E5090',
            'width': '0'
          }
        },
        'hover_style': {
          'color': '#ffffff',
          'backgroundColor': '#2E5090',
          'border': {
            'style': 'None',
            'color': '#2E5090',
            'width': '0'
          }
        },
        'active_style': {
          'color': '#ffffff',
          'backgroundColor': '#2E5090',
          'border': {
            'style': 'None',
            'color': '#2E5090',
            'width': '0'
          }
        }
      },
      'submit_button': {
        'text': 'Submit',
        'backgroundColor': '#2E5090',
        'width': '100',
        'alignment': 'right',
        'font': {
          'family': 'Poppins',
          'weight': '400',
          'size': '18',
          'line_height': '20',
          'color': '#ffffff',
          'height': '50'
        },
        'borderRadius': 'lg',
        'shadow': false,
        'icon': 'navigate_next',
        'default_style': {
          'border': {
            'style': 'None',
            'color': '#2E5090',
            'width': '0'
          }
        },
        'hover_style': {
          'color': '#ffffff',
          'backgroundColor': '#2E5090',
          'border': {
            'style': 'None',
            'color': '#2E5090',
            'width': '0'
          }
        },
        'active_style': {
          'color': '#ffffff',
          'backgroundColor': '#2E5090',
          'border': {
            'style': 'None',
            'color': '#2E5090',
            'width': '0'
          }
        }
      }
    },
    'step_progress': {
      'type': 'linear_progress',
      'showProgress': true,
      'showAnimation': true,
      'progressPosition': 'Top',
      'isStriped': 'true',
      'height': 'default',
      'config': {
        'fill_color': '#2E5090',
        'stroke_color': '#2E5090'
      }
    },
    'radio_checkbox': {
      'margin': '10',
      'radius': 'lg',
      'checked_color': '#2E5090',
      'hover_color': '#2E5090',
      'font': {
        'size': '15',
        'line_height': '40'
      },
      'default_style': {
        'color': '#2E2E2E',
        'backgroundcolor': '#F6F8FA',
        'border': {
          'style': 'Solid',
          'color': '#E87722',
          'width': '1'
        }
      },
      'hover_style': {
        'color': '#FFFFFF',
        'border': {
          'style': 'Solid',
          'color': '#E87722',
          'width': '0'
        }
      },
      'active_style': {
        'color': '#FFFFFF',
        'border': {
          'style': 'Solid',
          'color': '#E87722',
          'width': '0'
        }
      }
    },
    'choice': {
      'image_icon_skin': {
        'background_color': '#ffffff',
        'border': {
          'style': 'solid',
          'color': '#E5E7EB',
          'width': '1',
          'radius': 'lg'
        },
        'padding': {
          'top': '15',
          'right': '15',
          'bottom': '15',
          'left': '15'
        },
        'width': '100',
        'height': '20',
        'title_font': {
          'family': 'Montserrat',
          'weight': '700',
          'size': '14',
          'line_height': '20',
          'color': '#2E2E2E',
          'height': '30'
        },
        'description_font': {
          'family': 'Poppins',
          'weight': '500',
          'size': '12',
          'line_height': '20',
          'color': '#6B7280',
          'height': '30'
        },
        'tickbox': {
          'color': '#2E5090'
        },
        'icon_size': '45',
        'icon_color': '#2E5090',
        'image_width': '100',
        'shadow': false,
        'hover_style': {
          'background_color': '#ffffff',
          'border': {
            'style': 'solid',
            'color': '#E87722',
            'width': '1'
          },
          'title_font': {
            'color': '#E87722'
          },
          'description_font': {
            'color': '#6B7280'
          },
          'icon_color': '#E87722',
          'shadow': false
        },
        'active_style': {
          'background_color': '#ffffff',
          'border': {
            'style': 'solid',
            'color': '#2E5090',
            'width': '1'
          },
          'title_font': {
            'color': '#2E2E2E'
          },
          'description_font': {
            'color': '#6B7280'
          },
          'icon_color': '#2E5090',
          'shadow': false
        }
      },
      'dropdown_skin': {
        'default_style': {
          'color': '#2E5090'
        }
      }
    },
    'scale': {
      'selector_size': '34',
      'selector_color': '#E87722',
      'smileys_color': '#E87722',
      'smileys_text_color': '#2E2E2E',
      'border_color': '#2E5090',
      'config': {
        'fill_color': '#2E5090',
        'stroke_color': '#F1C09B'
      },
      'hover_style': {
        'smileys_hover_color': '#F7AB72'
      },
      'active_style': {
        'smileys_active_color': '#2E5090',
        'smileys_active_text_color': '#2E2E2E'
      }
    },
    'yes_no': {
      'default_style': {
        'color': '#2E5090',
        'text_color': '#6B7280'
      },
      'active_style': {
        'color': '#E87722',
        'text_color': '#2E2E2E'
      }
    },
    'otp': {
      'input': {
        'variant': 'outlined'
      },
      'general_style': {
        'border_radius': 'lg'
      },
      'verify_button': {
        'variant': 'flat',
        'text_color': '#ffffff',
        'background_color': '#2E5090'
      },
      'cancel_button': {
        'variant': 'outlined',
        'text_color': '#E87722',
        'border_color': '#E87722'
      }
    },
    // The payment card is always rendered on a white surface, so its text colours are defaults of
    // their own rather than the form's typography colours (which are tuned for the form background
    // and are often light). Keys mirror leadgenform's design.js `paymentStyles()` exactly.
    'payment': {
      // Blank means "follow the form's Primary Font Family" - see paymentStyles() in leadgenform's
      // mixins/design.js. Only diverges when someone deliberately picks a typeface.
      'font_family': '',
      'title_color': '#1F2937',
      'description_color': '#6B7280',
      'button_radius': 'lg',
      'button': {
        'text_color': '#ffffff',
        'background_color': '#2E5090'
      },
      // Brand blue unchecked, accent orange checked - the form's own two colours.
      'checkbox': {
        'default_style': {
          'color': '#2E5090'
        },
        'active_style': {
          'color': '#E87722'
        }
      }
    }
  },
  'custom_css': ''
}
